module.exports = __webpack_public_path__ + "img/logo-smolke.9464740b.svg";